import {
    ROOT,
    RESTRICTION_PACKAGE_GET_ALL,
    RESTRICTION_PACKAGE_UPDATE_STATUS,
    RESTRICTION_PACKAGE_DELETE,
    RESTRICTION_PACKAGE_DETAIL,
    RESTRICTION_PACKAGE_UPDATE,
    RESTRICTION_PACKAGE_CREATE,
    RESTRICTION_GET_ALL,
    RESTRICTION_GET_ALL_BY_ROOMTYPE,
    RESTRICTION_GET_ALL_BY_RATEPLAN,
    RESTRICTION_GET_ALL_ROOMTYPE_HAS_ROOMRATE,
    RESTRICTION_GET_ALL_OTA_HAS_ROOMRATE,
    RESTRICTION_GET_ALL_ROOMPLAN_HAS_ROOMRATE,
    RESTRICTION_BATCH_UPDATE,
  } from "@/_helpers/constant.js";
  import { requestOptions, handleResponse } from "@/_helpers";
  
  function getAllPackageRestriction(data) {
    return fetch(ROOT + RESTRICTION_PACKAGE_GET_ALL, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updatePackageRestrictionStatus(data) {
    return fetch(ROOT + RESTRICTION_PACKAGE_UPDATE_STATUS, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function deletePackageRestriction(id) {
    return fetch(ROOT + RESTRICTION_PACKAGE_DELETE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
  }

  function detailPackageRestriction(id) {
    return fetch(ROOT + RESTRICTION_PACKAGE_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
  }

  function updatePackageRestriction(data) {
    return fetch(ROOT + RESTRICTION_PACKAGE_UPDATE, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function createPackageRestriction(data) {
    return fetch(ROOT + RESTRICTION_PACKAGE_CREATE, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function getAllRestriction(data) {
    return fetch(ROOT + RESTRICTION_GET_ALL, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllRestrictionByRoomtype(data) {
    return fetch(ROOT + RESTRICTION_GET_ALL_BY_ROOMTYPE, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllRestrictionByRateplan(data) {
    return fetch(ROOT + RESTRICTION_GET_ALL_BY_RATEPLAN, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllRoomTyeHasRoomRate(data) {
    return fetch(ROOT + RESTRICTION_GET_ALL_ROOMTYPE_HAS_ROOMRATE, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllOtaHasRoomRate(otaId) {
    return fetch(ROOT + RESTRICTION_GET_ALL_OTA_HAS_ROOMRATE + '/' + otaId, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllRoomPlanHasRoomRate(data) {
    return fetch(ROOT + RESTRICTION_GET_ALL_ROOMPLAN_HAS_ROOMRATE, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function batchUpdate(data) {
    return fetch(ROOT + RESTRICTION_BATCH_UPDATE, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  //#endregion
  export const restriction = {
    getAllPackageRestriction,
    updatePackageRestrictionStatus,
    deletePackageRestriction,
    detailPackageRestriction,
    updatePackageRestriction,
    createPackageRestriction,
    getAllRestriction,
    getAllRestrictionByRoomtype,
    getAllRestrictionByRateplan,
    getAllRoomTyeHasRoomRate,
    getAllOtaHasRoomRate,
    getAllRoomPlanHasRoomRate,
    batchUpdate
  };
  